import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    width: 'clamp(332px, 43.23vw, 885px)',
    display: 'flex',
    flexDirection: 'column',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
    gap: 'clamp(12px, 1.56vw, 32px)',
    padding: 'clamp(16px, 2.08vw, 43px)',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 'clamp(10px, 1.30vw, 27px)',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  modalTitleIcon: {
    '&.MuiSvgIcon-root': {
      fontSize: 'clamp(12px, 1.60vw, 34px)',
    },
  },
  modalTitleAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingLeft: '10px',
  },
  modalTextfieldsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 'clamp(12px, 1.56vw, 32px)',
    columnGap: 'clamp(8px, 1.04vw, 21px)',
  },
  modalIndividualTextfield: {
    display: 'flex',
    width: 'clamp(146px, 19.01vw, 389px)',
  },
  modalButtonsContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  modalAddButton: {
    width: 'clamp(112px, 14.58vw, 299px)',
    height: 'clamp(20px, 2.60vw, 53px)',
    fontSize: 'clamp(8px, 1vw, 21px)',
    fontWeight: 500,
    fontFamily: 'Montserrat',
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: 'clamp(8px, 1.04vw, 21px)',
    },
  },
}));

export default useStyles;
